import { capitalizeFirstLetter } from '@va/util/helpers';
import { AxiosError } from 'axios';
import {
  activateCompanyDomain,
  activateSenderEmail,
  activateWebsiteDomain,
  cancelPendingCompanyDomain,
  cancelPendingSenderEmail,
  cancelPendingWebsiteDomain,
  checkDNS,
  createCompanyDomain,
  createOrUpdateAgencyCustomSubdomain,
  createSenderEmail,
  createWebsiteDomain,
  deleteCompanyDomain,
  deleteSenderEmail,
  deleteWebsiteDomain,
  getTargetedDNSRecords,
  listCompanyDomainsByType,
  listDNSRecords,
  listSenderEmails,
  listWebsiteDomainsByType,
  sendDummyEmail,
  updateCustomSenderName,
} from './custom-domains.api';
import {
  useCreateSenderEmail,
  useDNSCheck,
  useGetTargetedDNSRecords,
  useListCompanyDomainsByType,
  useListDNSRecords,
  useListSenderEmails,
  useListWebsiteDomainsByType,
  useSendDummyEmail,
} from './custom-domains.api.hooks';

export const CustomDomainsApi = {
  listDNSRecords,
  checkDNS,
  getTargetedDNSRecords,
  listSenderEmails,
  createSenderEmail,
  deleteSenderEmail,
  activateSenderEmail,
  updateCustomSenderName,
  cancelPendingSenderEmail,
  createOrUpdateAgencyCustomSubdomain,
  useListDNSRecords,
  useListSenderEmails,
  useCreateSenderEmail,
  useGetTargetedDNSRecords,
  useDNSCheck,
  extractApiErrorMessage,
  sendDummyEmail,
  useSendDummyEmail,

  // companies
  cancelPendingCompanyDomain,
  deleteCompanyDomain,
  activateCompanyDomain,
  createCompanyDomain,
  listCompanyDomainsByType,
  useListCompanyDomainsByType,

  //websites
  cancelPendingWebsiteDomain,
  deleteWebsiteDomain,
  activateWebsiteDomain,
  createWebsiteDomain,
  listWebsiteDomainsByType,
  useListWebsiteDomainsByType,
};

export * from './custom-domains.api.types';

function extractApiErrorMessage(error: unknown, t: (s: string) => any): string {
  let msg = t('notifications.generalError');

  if (error instanceof AxiosError) {
    const detail = error.response?.data?.['detail'];
    if (detail) {
      msg = capitalizeFirstLetter(detail);
    }
  }
  return msg;
}
